import React, {useState} from 'react';
import {
    MDBBtn, MDBModal, MDBModalBody, MDBModalContent,
    MDBModalFooter, MDBModalHeader, MDBModalTitle, MDBModalDialog,
    MDBInput, MDBValidation
} from 'mdb-react-ui-kit';

interface DialogNewProjectProps {
    createNewProject : (name : string) => Promise<boolean>;
    showDialog : boolean;   
    setShowProjectDialog : (state : boolean) => void;
}

export default function DialogNewProject(props : DialogNewProjectProps) {

    const [input, setInput] = useState<string>("");
    const [errorMsg, setErrorMsg] = useState<string>("");

    if (!props.showDialog){
        return <></>
    }

    const addNewProject = async () => {
        let newProject = await props.createNewProject(input);
        if (newProject) props.setShowProjectDialog(false);
        else setErrorMsg("This project already exists. Please choose a different name.")
    }

    const checkForButtonPress = (event: any) => {
        if(event.key === 'Enter'){
            event.preventDefault();
            if (input) {
                addNewProject();
            }
        }
    }

    return  <MDBModal staticBackdrop show={props.showDialog}>
                <MDBModalDialog>
                    <MDBValidation isValidated>
                        <MDBModalContent>
                            <MDBModalHeader>
                                <MDBModalTitle>Create new Project</MDBModalTitle>
                                <MDBBtn className='btn-close' color='none' onClick={() => {props.setShowProjectDialog(false)}}></MDBBtn>
                            </MDBModalHeader>
                            <MDBModalBody>
                                <p>Please fill in the project name</p>
                                <MDBInput autoFocus='autofocus' id='newProjectName' onChange={(e : any) => {setInput(e.target.value); setErrorMsg("")}} onKeyPress={checkForButtonPress} required label='Project name'/>
                                <p style={{ paddingTop: '0px', color: 'red'}}>{errorMsg}</p>
                            </MDBModalBody>
                            <MDBModalFooter>
                                <MDBBtn type='submit' disabled={!input} onClick={() => { addNewProject() }}>Add new Project</MDBBtn>
                                <MDBBtn onClick={() => { props.setShowProjectDialog(false); console.log(input) }}>Cancel</MDBBtn>
                            </MDBModalFooter>
                        </MDBModalContent>
                    </MDBValidation>
                </MDBModalDialog>
            </MDBModal>
;}